import PersistScroll from './PersistScroll';

export default PersistScroll;
